import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isDateStringValidPattern(regexPattern: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    regexPattern.test(control.value)
      ? null
      : {
          validDateStringPattern: {
            valid: false
          }
        };
}
